<div class="package-filters-container">
  <div class="search-bar">
    <img src="assets/images/package/search.svg" alt="Search" />
    <input 
      type="text" 
      placeholder="Search for packages.." 
      [(ngModel)]="searchText"
      (input)="onSearchInput($event)"
      (keyup.enter)="onSearchInput($event)"
    />
    <button 
      *ngIf="searchText" 
      class="clear-search" 
      (click)="clearSearch()"
      type="button"
    >
      ×
    </button>
  </div>
  <div class="actions-container">
    <div class="view-switcher">
      <button (click)="setActiveView('grid')" [class.active]="activeView === 'grid'">
        <img src="assets/images/package/layout-grid.svg" alt="Grid" />
        <span>Grid</span>
      </button>
      <button (click)="setActiveView('list')" [class.active]="activeView === 'list'">
        <img src="assets/images/package/Variant3.svg" alt="List" />
        <span>List</span>
      </button>
    </div>
    <button class="filter-button" (click)="showFilterModal()">
     
      <span>Filter</span>  <img src="assets/images/package/adjustments.svg" alt="Filter" />
      <span class="filter-count" *ngIf="hasActiveFilters()">{{ getActiveFilterCount() }}</span>
    </button>
  </div>

  <!-- Filter Modal -->
  
</div> 
  <app-package-filter-modal
    [isVisible]="isFilterModalVisible"
    [currentFilters]="currentFilters"
    (closeModal)="closeFilterModal()"
    (applyFilters)="onFiltersApplied($event)"
    (clearFilters)="onFiltersCleared()"
    (sortTable)="onSortTable($event)"
  ></app-package-filter-modal>